/*
 * ih.notification
 *      ih.notify, ih.success, ih.reminder, ih.waiting, ih.warning, ih.error
 * 
 * 
 * Notifications are small, non-modal dialogs that slide in over the page content.
 * They usually auto-close after a few seconds, or can be dismissed manually by clicking the close button.
 * 
 * 
 * Positioning:
 * 
 * Notifications either slide down from the top of the page or up from the bottom.
 * They can be positioned left, right, or center.
 * They are always sticky.
 * The default position for all types is top-center.
 * 
 * 
 * Types:
 * 
 * The default notification is black with white text and no icon, and auto-closes after 2 seconds.
 * Several additional notification types are setup with pre-configured color, icon, and auto-close options.
 * 
 * 
 * -------------------------------
 * USAGE
 * -------------------------------
 * 
 * Basic:
 * 
 * ih.notify("Your message");
 * 
 * 
 * Type presets:                                Aliases:
 * 
 * ih.notify("Your message", "success");        ih.success("Your message");
 * ih.notify("Your message", "reminder");       ih.reminder("Your message");
 * ih.notify("Your message", "waiting");        ih.waiting("Your message");
 * ih.notify("Your message", "warning");        ih.warning("Your message");
 * ih.notify("Your message", "error");          ih.error("Your message");
 * 
 * 
 * Options:
 * Note that you can use a type string or the options hash as the 2nd argument.
 * 
 * ih.notify("Your message", "warning", { options... });
 * ih.notify("Your message", { options... });
 * 
 * 
 * 
 */
var ih = ih || {};

(function($) {
    ih.notification = function(options) {
        var _this = this; // class instance
        var _autoCloseTimer;

        var _default_settings = {
            cssClass: false,        // string extra css classes to add to the notification div in addition to "ih-notification"
            icon: false,            // html for icon to prepend to the message
            message: false,         // string value: REQUIRED
            type: false,            // string: success|reminder|waiting|warning|error
            position: "top-center", // string: top-left|top-center|top-right|bottom-left|bottom-center|bottom-right
            closeButton: true,      // whether or not to include the close X button.
            autoClose: 2            // false or number of seconds for how long to wait before autoClosing
        };
        
        // type presets
        // the type option acts as an alias for a combination of settings 
        var _default_type_settings = {
            success: {
                cssClass: "ih-notification-success",
                icon: "<span class='ih-icon-checkmark-circle'></span>",
                autoClose: 2
            },
            reminder: {
                cssClass: "ih-notification-reminder",
                icon: "<span class='ih-icon-alarm ih-anim-bounce infinite'></span>",
                autoClose: false
            },
            waiting: {
                cssClass: "ih-notification-waiting",
                icon: "<span class='ih-modal-spinner-icon ih-anim-spin infinite'></span>",
                autoClose: false
            },
            warning: {
                cssClass: "ih-notification-warning",
                icon: "<span class='ih-icon-warning'></span>",
                autoClose: false
            },
            error: {
                cssClass: "ih-notification-error",
                icon: "<span class='ih-icon-cancel-circle'></span>",
                autoClose: false
            }
        };
        
        // if there's a valid type specified, use those settings
        if (options && options.type && _default_type_settings[options.type]) {
            options = $.extend( _default_type_settings[options.type], options);
        }
        
        // now merge in explicit options - these take priority 
        var _settings = $.extend( _default_settings, options);
        var _isOpen = false;
        
        
        // build the DOM
        
        
        // If a layer already exists for this position, use it. Or else create a new layer.
        // Multiple layers can exist at the same time, but only one for each position
        // Each position layer can contain multiple notifications.
        
        // Notifications are re-created fresh with each instance and destroyed on close.
        
        var layerClass = "ih-notification-layer-" + _settings.position;
        var $layer = ( $("."+layerClass).length ) ? $("."+layerClass) : $(templates.layer).addClass(layerClass).appendTo("body");
        
        var $notification = $( templates.notification );
        var $message = $notification.find(".ih-notification-message");


        // builds the content of a notification - 
        // used both for initial setup and when updating a notification
        this._build = function(update) {
            // if updating, strip back down to default first
            if ( update ) {
                $notification.removeClass().addClass("ih-notification open");
                
                // stop the notification from closing and use new autoClose settings.
                clearTimeout(_autoCloseTimer);
                if ( _settings.autoClose ) {
                    _autoCloseTimer = setTimeout( function() {
                        _this.close();
                    }, parseInt(_settings.autoClose) * 1000);
                }
            }
            
            // build
            if ( _settings.cssClass ) {
                $notification.addClass( _settings.cssClass );
            }
            if ( _settings.icon ) {
                $notification.addClass("has-icon");
            }
            if ( _settings.closeButton ) {
                $notification.addClass("has-close-x");
            }

            if ( _settings.message ) {
                if ( _settings.icon ) {
                    $message.html( _settings.icon + " " + _settings.message );
                }
                else {
                    $message.html( _settings.message );
                }
            }

            if ( _settings.closeButton ) {
                $( templates.closeButton ).appendTo( $notification );
            }
            else {
                $notification.find(".ih-notification-close-x").remove();
            }
        },


        // public functions


        // open the notification
        this.open = function() {
            _isOpen = true;
            
            // add the notification to the layer
            $notification.prependTo( $layer );

            // timeout of any duration allows the css transition to render correctly.
            setTimeout( function() {
                $notification.addClass("open");
            }, 1 );

            if ( _settings.autoClose ) {
                _autoCloseTimer = setTimeout( function() {
                    _this.close();
                }, parseInt(_settings.autoClose) * 1000);
            }
        };


        // update the message (and options) for this notification
        this.update = function(message, type, options) {
            if ( _isOpen ) {
                
                // cache current position option. It is fixed in this case so
                // we'll be forcing it to be the same regardless of any options specified.
                var pos = _settings.position;
                
                // check if the 2nd param is a type string or the options hash
                var type = type;
                var newOptions = options;
                
                if ( type && typeof type === 'string') {
                    _settings.type = type;
                }
                else if ( type === false ) {
                    _settings.type = false;
                }
                else {
                    newOptions = type;
                }
                
                // if there's a valid type specified, use those settings
                if (newOptions && newOptions.type && _default_type_settings[newOptions.type]) {
                    _settings.type = newOptions.type;
                }
                if ( _default_type_settings[_settings.type] ) {
                    newOptions = $.extend( _default_type_settings[_settings.type], newOptions);
                }
                
                var newSettings = $.extend( true, _settings, newOptions);
                _settings = newSettings;
                _settings.position = pos;
                
                
                // if a message was provided as the first argument, use it.
                if ( message ) {
                    _settings.message = message;
                }
                // if message was provided as part of options, that takes priority over everything else
                if ( options && options.message ) {
                    _settings.message = options.message;
                }
                
                this._build(true);
                
                return this;
            }
        },


        this.close = function() {
            if (_isOpen) {
                _isOpen = false;
                
                if (_settings.autoClose) {
                    clearTimeout(_autoCloseTimer);
                }
                
                // unbind notification events, close and remove from DOM
                $notification.off().removeClass("open").addClass("closing");
                setTimeout( function() {
                    $notification.remove();
                    
                    // if the layer is empty of notifications now, then remove it too
                    if ( ! $layer.children().length ) {
                        $layer.remove();
                    }
                    
                }, 500 );
            }
        };


        this._build();
        
        // attach events to the notification
        $notification.on("click", ".ih-notification-close-x", function(e) {
            e.preventDefault();
            _this.close();
        });
        
        this.open();
        
        return this;
    };



    ih.notify = function(message, type, options) {
        var _default_settings = {
            message: message
        };
        
        // check if the 2nd param is a type string or the options hash
        var options = options;
        if ( type && typeof type === 'string') {
            _default_settings.type = type;
        }
        else if ( type === false ) {
            _default_settings.type = false;
        }
        else {
            options = type;
        }
        
        var _settings = $.extend( true, _default_settings, options);
        return new ih.notification( _settings );
    };



    // Aliases for notification types
    ih.success = function(message, options) {
        return new ih.notify(message, "success", options);
    };
    ih.reminder = function(message, options) {
        return new ih.notify(message, "reminder", options);
    };
    ih.waiting = function(message, options) {
        return new ih.notify(message, "waiting", options);
    };
    ih.warning = function(message, options) {
        return new ih.notify(message, "warning", options);
    };
    ih.error = function(message, options) {
        return new ih.notify(message, "error", options);
    };



    var templates = {
        layer:
            "<div class='ih-notification-layer'></div>",
        notification:
            "<div class='ih-notification' tabindex='-1' role='dialog'>" +
                "<div class='ih-notification-message'></div>" +
            "</div>",
        closeButton:
            "<button type='button' class='ih-notification-close-x' aria-hidden='true' tabindex='-1'>&times;</button>",
    };


})(jQuery);